import React from 'react';
import { Grid } from '@mui/material';
import useLoadingStyles from '../../styles/loading/loading.style';
import PortalThemeProvider from '../../context/PortalThemeProvider';
import { PiLoading } from '@sensei/pi-component';

type Props = {
    message: string;
};
export default function LoadingPage(props: Props) {
    const classes = useLoadingStyles();

    return (
        <PortalThemeProvider>
            <Grid
                className={classes.grid}
                container
                spacing={0}
                direction="column"
                alignItems="center"
                justifyContent="center"
                style={{ minHeight: '100vh' }}
            >
                <PiLoading message={props.message} />
            </Grid>
        </PortalThemeProvider>
    );
}
